export default __webpack_public_path__ + "static/media/personnel.ffcea3c7.svg";